import React,  { Component } from 'react'
import PlanningDetailsItem from '../../../Domain/PlanningDetailsItem';
import TabListTable from '../../../Elements/TabListTable';



class PlanningDetailListDetailsBox extends Component {

    constructor(props) {
        super(props);
        this.state = {
            itemId: props.id,
            planningDetailItemDetails: props.item,
            loading: false,
            submitHandlerInPlanningDetailList: props.submitHandler
        };
    }

    componentDidMount() {
        
    }

    
    UNSAFE_componentWillReceiveProps(nextProps)
    {
        this.setState({
            planningDetailItemDetails: nextProps.item,
        });
    }


   
    renderPlanningDetailItemDetailsRow()
    {
        return (
            <div>
                <div className="m-1">
                    <TabListTable
                        caption="PlanningDetail Item Details"
                        data={this.props.item} 
                        moneyFields={PlanningDetailsItem.MoneyFields}
                        moneyFieldsSecondary={PlanningDetailsItem.MoneyFieldsSecondary}
                        dateFields={PlanningDetailsItem.DateFields}
                        currency={this.props.item.FieldworkOfficeCurrency}
                        currencySecondary={this.props.item.OwningOfficeCurrency}
                        fieldsToShow={PlanningDetailsItem.FieldsToShowInListTable}
                    />
                </div>
                <div className="container m-1">
                    <div className="row">
                        <div className="col">
                            <input 
                                className="form-control"
                                type="button"
                                value="Close"
                                onClick={()=>{
                                    this.props.cancelHandler();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            );
    }

    render()
    {
        return this.renderPlanningDetailItemDetailsRow();
    }
}


export default PlanningDetailListDetailsBox;
